<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" class="scaling-svg">
      <path
        d="M11.556,14H1.444A1.424,1.424,0,0,1,0,12.6V1.4A1.424,1.424,0,0,1,1.444,0H11.556A1.424,1.424,0,0,1,13,1.4V12.6A1.424,1.424,0,0,1,11.556,14ZM2.166,1.4a.712.712,0,0,0-.722.7v9.8a.712.712,0,0,0,.722.7h8.667a.712.712,0,0,0,.722-.7V2.1a.712.712,0,0,0-.722-.7Z"
      />
      <path
        d="M0,.7A.7.7,0,0,1,.7,0H6.3A.7.7,0,0,1,7,.7v.7a.7.7,0,0,1-.7.7H.7A.7.7,0,0,1,0,1.4Z"
        transform="translate(2.5 2.8)"
      />
      <path d="M0,.7a.7.7,0,1,1,.7.7A.7.7,0,0,1,0,.7Z" transform="translate(2.5 6.3)" />
      <path d="M0,.7a.7.7,0,1,1,.7.7A.7.7,0,0,1,0,.7Z" transform="translate(5.3 6.3)" />
      <path d="M0,.7a.7.7,0,1,1,.7.7A.7.7,0,0,1,0,.7Z" transform="translate(8.1 6.3)" />
      <path d="M0,.7a.7.7,0,1,1,.7.7A.7.7,0,0,1,0,.7Z" transform="translate(2.5 9.1)" />
      <path d="M0,.7a.7.7,0,1,1,.7.7A.7.7,0,0,1,0,.7Z" transform="translate(5.3 9.1)" />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CalcIcon extends Vue {}
</script>

<style>
</style>
